'use client';

import { ErrorMessage } from 'formik';

import Text from '@commons/components/Text';
import { Flex, type FlexProps } from '@commons/containers/Flex';
import type { Spacing } from '@commons/types/styles';

import styles from './index.module.scss';

// Type definition for the Field Group Component

type FieldGroupProps = FlexProps & {
  name: string;
  direction?: 'row' | 'column';
  required?: boolean;
  error?: boolean;
  spacing?: Spacing;
};

/**
 * FieldGroup Component
 *
 * A wrapper component for form fields that handles label placement, layout direction,
 * and displays validation error messages when necessary.
 */

export const FieldGroup = ({
  children,
  name,
  direction = 'column',
  spacing = 'lg',
  ...flexProps
}: FieldGroupProps) => {
  return (
    <Flex
      direction={direction}
      marginBottom={spacing}
      width={12}
      {...flexProps}
      className={styles.wrapper}
    >
      {children}
      <ErrorMessage
        name={name}
        render={(msg) => (
          <Text
            as="span"
            level="label-sm"
            color="orange-2"
            transform="uppercase"
            className={styles.errorMessage}
          >
            {msg}
          </Text>
        )}
      />
    </Flex>
  );
};
